import type { ReservationSettings, LargeGroupContactMethod } from '@/hooks/useReservationSettings';

/**
 * Get the large group message text and contact info for display
 */
export function getLargeGroupDisplay(settings: ReservationSettings) {
  const method = settings.largeGroupContactMethod || 'email';
  const contact = method === 'email' ? settings.largeGroupEmail : settings.largeGroupPhone;
  
  if (!contact) return null;

  const defaultMessage = method === 'email'
    ? `Pour les groupes de plus de ${settings.maxPeople} personnes, merci de nous contacter :`
    : `Pour les groupes de plus de ${settings.maxPeople} personnes, merci de nous appeler :`;

  const message = settings.largeGroupMessage
    ? settings.largeGroupMessage
        .replace('{maxPeople}', String(settings.maxPeople))
        .replace('{contact}', contact)
    : defaultMessage;

  const href = method === 'email' ? `mailto:${contact}` : `tel:${contact}`;

  return { message, contact, href, method };
}

/**
 * Check if the large group message should be shown
 */
export function shouldShowLargeGroupMessage(settings: ReservationSettings | null): boolean {
  if (!settings?.largeGroupEmailEnabled) return false;
  const method = settings.largeGroupContactMethod || 'email';
  if (method === 'email') return !!settings.largeGroupEmail;
  return !!settings.largeGroupPhone;
}
